export const FOTO_FLAT = 'FotoFlat';
export const SINGLE_PHOTO = 'SingleFoto';
export const PHOTO_DVD = 'FotoCD';
export const PHOTO_BOOK = 'FotoBook';

export const IMPRESSION = 'impressions';
export const PARTICIPANT = 'participant';
export const CATEGORY = 'categories';
export const SUGGESTION = 'suggestions';
export const GPS = 'gps';
export const ACCOUNT = 'account';

// All types of photos
// It's recommended to add new types here as well
export const ORIGINAL = 'original';
export const PREVIEW = 'preview';
export const SOCIAL_MEDIA = 'socialmedia';
export const THUMBNAIL = 'thumbnail';

// Money transfer options
export const PAYPAL = 'PayPal';
export const BANKTRANSFER = 'BankTransfer';

export const PAYMENT_COMPLETED = 'payment_completed';
export const COMPLETED = 'completed';
export const PAYMENT_FAILED = 'payment_failed';
export const PAYMENT_IN_PROGRESS = 'payment_in_progress';
export const IN_PAYMENT = 'in_payment';

export const REGISTER_STEP = 0;
export const ADDRESS_STEP = 1;
export const PAYMENT_STEP = 2;

export const MAGIC_LINK_SENT_MSG = 'magic link sent';
export const MAGIC_LINK_EXPLANATION_MSG = 'maigc link explanation';
export const MAGIC_LINK_EXPIRED_MSG = 'magic link is experied';
export const NEW_SYSTEM_ORDER_REDIRECT_MSG = 'order id of new system redirect';
export const PHOTO_DVD_EXPLANATION_MSG = 'photo dvd explanation';
export const PHOTO_BOOK_MOBILE_MSG = 'photo book mobile';
export const PHOTO_BOOK_SHIPPING_CHARGES_MSG = 'photo book shipping charges overview';
export const FRESHDESK_PAYPAL_CANCELLED_MSG = 'freshdesk paypal cancelled';

export const ALL_PHOTOS_CATEGORY = 'allphotos';

export const PENDING = 'reminder';

// Second factor types
export const FACTOR_DATE_OF_BIRTH = 'Birthday';
export const FACTOR_EMAIL = 'Email';
export const FACTOR_YEAR_OF_BIRTH = 'Year of birth';
